import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all maintenancePlans
export const getMaintenancePlans = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/maintenance-plans`);
    return response.data;
  } catch (error) {
    console.error("Error fetching maintenancePlans:", error.response?.data || error);
    throw error;
  }
};

// GET a single maintenancePlan
export const getMaintenancePlanById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/maintenance-plans/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching maintenancePlan:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new maintenancePlan
export const createMaintenancePlan = async (maintenancePlanData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/maintenance-plans`, maintenancePlanData);
    return response.data;
  } catch (error) {
    console.error("Error creating maintenancePlan:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing maintenancePlan
export const updateMaintenancePlan = async (id, maintenancePlanData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/maintenance-plans/${id}`, maintenancePlanData);
    return response.data;
  } catch (error) {
    console.error("Error updating maintenancePlan:", error.response?.data || error);
    throw error;
  }
};

// DELETE a maintenancePlan
export const deleteMaintenancePlan = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/maintenance-plans/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting maintenancePlan:", error.response?.data || error);
    throw error;
  }
};

// GET paginated maintenance plans
export const getPaginatedMaintenancePlans = async ({ 
  page = 1, 
  pageSize = 25, 
  search = '',
  taskTypeId,
  groupIds, 
}) => {
  const response = await axiosInstance.get(`${API_URL}/maintenance-plans`, {    params: { 
      page, 
      pageSize, 
      search, 
      taskTypeId, 
      groupIds 
    },
    paramsSerializer: params => {
      const query = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach(v => query.append(key, v));
        } else if (value !== undefined && value !== null) {
          query.append(key, value);
        }
      }
      return query.toString();
    },
  });
  return response.data;
};

